import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const STORAGE_KEY = "reversia_cookie_consent";

const CookiePolicyModal = ({ onClose }) => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 1100,
      background: "rgba(15,23,42,0.75)",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "center",
      padding: "0",
    }}
    onClick={onClose}
  >
    <div
      onClick={e => e.stopPropagation()}
      style={{
        background: "var(--rv-white)",
        width: "100%",
        maxWidth: "720px",
        maxHeight: "80vh",
        overflowY: "auto",
        borderRadius: "16px 16px 0 0",
        padding: "28px 24px 32px",
        fontFamily: "IBM Plex Sans, sans-serif",
        color: "var(--rv-text-primary)",
        boxShadow: "0 -8px 40px rgba(0,0,0,0.2)",
        animation: "cpModalUp 0.3s cubic-bezier(0.16,1,0.3,1) both",
      }}
    >
      <style>{`
        @keyframes cpModalUp {
          from { transform: translateY(60px); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }
        .cp-section-title {
          font-family: Manrope, sans-serif;
          font-size: 17px;
          font-weight: 700;
          color: var(--rv-navy);
          margin: 20px 0 8px;
        }
        .cp-text {
          font-size: 14px;
          line-height: 1.65;
          color: var(--rv-text-secondary);
          margin-bottom: 10px;
        }
        .cp-list {
          padding-left: 18px;
          margin: 8px 0 12px;
        }
        .cp-list li {
          font-size: 14px;
          line-height: 1.65;
          color: var(--rv-text-secondary);
          margin-bottom: 8px;
        }
        .cp-list li b {
          color: var(--rv-navy);
        }
      `}</style>

      {/* Заголовок */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "4px" }}>
        <h2 style={{ fontFamily: "Manrope, sans-serif", fontSize: "20px", fontWeight: 800, color: "var(--rv-navy)", margin: 0 }}>
          Политика использования cookie
        </h2>
        <button
          onClick={onClose}
          data-testid="cookie-modal-close"
          style={{ background: "none", border: "none", cursor: "pointer", color: "var(--rv-text-muted)", padding: "4px" }}
        >
          <X size={20} />
        </button>
      </div>
      <p className="cp-text" style={{ marginTop: "6px" }}>
        Настоящая политика описывает, какие файлы cookie использует платформа Реверсия и как вы можете управлять ими.
      </p>

      <div className="cp-section-title">Что такое файлы cookie</div>
      <p className="cp-text">
        Cookie — это небольшие текстовые файлы, которые сохраняются в вашем браузере при посещении сайта. Они помогают
        платформе запоминать ваши настройки и обеспечивать корректную работу функций.
      </p>

      <div className="cp-section-title">Согласие на использование</div>
      <p className="cp-text">
        Продолжая использовать сайт reversia.ru, вы даёте согласие на обработку файлов cookie. Вы можете отказаться от
        аналитических cookie — это не повлияет на основные функции платформы.
      </p>

      <div className="cp-section-title">Типы используемых cookie</div>
      <ul className="cp-list">
        <li>
          <b>Обязательные (технические).</b> Необходимы для работы платформы: авторизация, корзина, настройки сессии.
          Без них сайт не может функционировать. Не требуют согласия.
        </li>
        <li>
          <b>Сессионные.</b> Временные файлы, которые удаляются при закрытии браузера. Запоминают ваши действия в
          рамках одного визита, чтобы не приходилось повторно вводить данные.
        </li>
        <li>
          <b>Постоянные.</b> Сохраняются на устройстве после закрытия браузера. Позволяют узнавать вас при повторном
          визите и запоминать предпочтения (язык, регион, настройки интерфейса).
        </li>
        <li>
          <b>Аналитические (Яндекс.Метрика).</b> Используются для сбора обезличенной статистики посещаемости: какие
          страницы открываются, по каким ссылкам переходят пользователи. Данные передаются сервису Яндекс.Метрика для
          анализа работы платформы. Включают Вебвизор — запись действий пользователя на странице.
        </li>
      </ul>

      <div className="cp-section-title">Отказ от cookie</div>
      <p className="cp-text">
        Вы можете в любой момент заблокировать или удалить cookie в настройках вашего браузера. Также вы можете
        нажать кнопку «Отклонить» в баннере — аналитические cookie не будут использоваться, технические останутся
        активными для корректной работы сайта.
      </p>
      <p className="cp-text">
        Инструкции для браузеров: <b>Chrome</b> — Настройки &rarr; Конфиденциальность &rarr; Файлы cookie.{" "}
        <b>Firefox</b> — Настройки &rarr; Приватность &rarr; Куки. <b>Safari</b> — Настройки &rarr; Конфиденциальность.
      </p>

      <div className="cp-section-title">Контакты</div>
      <p className="cp-text">
        По вопросам обработки персональных данных и cookie обращайтесь:{" "}
        <a href="mailto:support@reversia.ru" style={{ color: "var(--rv-teal)" }}>support@reversia.ru</a>
      </p>

      <button
        onClick={onClose}
        data-testid="cookie-modal-close-bottom"
        style={{
          marginTop: "16px",
          width: "100%",
          background: "var(--rv-teal)",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          padding: "11px",
          fontSize: "14px",
          fontWeight: 600,
          fontFamily: "Manrope, sans-serif",
          cursor: "pointer",
        }}
      >
        Закрыть
      </button>
    </div>
  </div>
);

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
    setShowPolicy(false);
  };

  const handleDecline = () => {
    localStorage.setItem(STORAGE_KEY, "declined");
    setVisible(false);
    setShowPolicy(false);
  };

  if (!visible) return null;

  return (
    <>
      {showPolicy && <CookiePolicyModal onClose={() => setShowPolicy(false)} />}

      <div
        data-testid="cookie-banner"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          background: "var(--rv-navy-mid)",
          borderTop: "1px solid rgba(13,148,136,0.35)",
          boxShadow: "0 -2px 16px rgba(0,0,0,0.22)",
          animation: "cookieSlideUp 0.35s cubic-bezier(0.16,1,0.3,1) both",
        }}
      >
        <style>{`
          @keyframes cookieSlideUp {
            from { transform: translateY(100%); opacity: 0; }
            to   { transform: translateY(0);    opacity: 1; }
          }
        `}</style>

        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "12px 16px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          <p
            style={{
              flex: "1 1 240px",
              margin: 0,
              fontSize: "13px",
              lineHeight: "1.5",
              color: "#cbd5e1",
              fontFamily: "IBM Plex Sans, sans-serif",
            }}
          >
            Мы используем файлы cookie и Яндекс.Метрику для анализа посещаемости.{" "}
            <button
              onClick={() => setShowPolicy(true)}
              data-testid="cookie-privacy-link"
              style={{
                background: "none",
                border: "none",
                padding: 0,
                color: "var(--rv-teal)",
                fontSize: "13px",
                cursor: "pointer",
                textDecoration: "underline",
                fontFamily: "inherit",
              }}
            >
              Подробнее
            </button>
          </p>

          <div style={{ display: "flex", gap: "8px", flexShrink: 0, flexWrap: "wrap" }}>
            <button
              onClick={handleAccept}
              data-testid="cookie-accept-btn"
              style={{
                background: "var(--rv-teal)",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                padding: "7px 20px",
                fontSize: "13px",
                fontWeight: 600,
                fontFamily: "Manrope, sans-serif",
                cursor: "pointer",
                whiteSpace: "nowrap",
                transition: "background 0.2s",
              }}
              onMouseEnter={e => (e.target.style.background = "var(--rv-teal-dark)")}
              onMouseLeave={e => (e.target.style.background = "var(--rv-teal)")}
            >
              Принять
            </button>
            <button
              onClick={handleDecline}
              data-testid="cookie-decline-btn"
              style={{
                background: "transparent",
                color: "#94a3b8",
                border: "1px solid #334155",
                borderRadius: "6px",
                padding: "7px 16px",
                fontSize: "13px",
                fontFamily: "Manrope, sans-serif",
                cursor: "pointer",
                whiteSpace: "nowrap",
                transition: "border-color 0.2s, color 0.2s",
              }}
              onMouseEnter={e => { e.target.style.borderColor = "#64748b"; e.target.style.color = "#cbd5e1"; }}
              onMouseLeave={e => { e.target.style.borderColor = "#334155"; e.target.style.color = "#94a3b8"; }}
            >
              Отклонить
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
